import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormServices } from 'src/app/services/form-services.service';
import { UiServices } from 'src/app/services/ui-services';

@Component({
  selector: 'app-data-product',
  templateUrl: './data-product.component.html',
  styleUrls: ['./data-product.component.scss'],
})
export class DataProductComponent implements OnInit {
  @Input() domainId;
  @Input() savedForm;
  @Output() segment = new EventEmitter();
  @Output() emitFormValue = new EventEmitter();
  fieldForms;
  constructor(private uiSv: UiServices, private formSv: FormServices) {}

  async ngOnInit() {
    try {
      await this.uiSv.showLoading();
      const res: any[] = await this.formSv.getForm('products', this.domainId);
      this.fieldForms = res;
      if (!res.length) {
        this.segment.emit('data');
      }
      await this.uiSv.loading.dismiss();
    } catch (err) {
      console.error(err);
      await this.uiSv.loading.dismiss();
    }
  }

  async sendInfo(ev) {
    try {
      this.emitFormValue.emit(ev);
    } catch (err) {
      console.error(err);
    }
  }
}
